module.exports = __webpack_public_path__ + "img/step3-mobile.40c7ddea.jpg";